import { render, staticRenderFns } from "./rails-errors.vue?vue&type=template&id=276b298e&"
import script from "./rails-errors.vue?vue&type=script&lang=js&"
export * from "./rails-errors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports